module.exports = __webpack_public_path__ + "static/media/afl-ver-cen-white.753baa2b.svg";